import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { DocumentReference } from "@angular/fire/compat/firestore";

export class AssignedClient extends FBase {

    reference: DocumentReference = null;

    constructor(json?: { [key: string]: any }) {
        super();
        if (isObject(json)) {
            this.fromJson(json);
        }
    }
}
export namespace AssignedClient {
    export const PATH = 'assignedClients';
}
